// Clasificación de comandos del log MQTT crudo — constante en el frontend,
// no en la DB, para poder reclasificar cuando aparezca tráfico real del
// piloto Xiaoma sin necesitar migración ni redeploy del backend.
//
// Solo incluye comandos definidos en docs/FARM_API_DATA_CAPTURE_INTEGRATION.md
// §8 (0xE6 + los 4 de control 485). Deliberadamente SIN Heartbeat/Info/Config
// Red — el protocolo documentado no los define como IDs de comando propios;
// se agregan acá en cuanto se confirme qué manda el device real (860549070395236)
// vía el botón "Ver JSON".
export interface CommandLabel {
  emoji: string;
  label: string;
}

export const COMMAND_LABELS: Record<string, CommandLabel> = {
  '0xe6': { emoji: '📊', label: 'Datos de sensores' },
  '0xdc': { emoji: '✅', label: 'Confirmación (485)' },
  '0x1d': { emoji: '🎛️', label: 'Consulta estado (485)' },
  '0xdd': { emoji: '🎛️', label: 'Respuesta estado (485)' },
  '0x1c': { emoji: '🎛️', label: 'Control salida (485)' },
};

export function classifyCommand(commandId: string | null, isBinary: boolean): CommandLabel {
  if (!isBinary) return { emoji: '📄', label: 'JSON / no-Xiaoma' };
  if (commandId && COMMAND_LABELS[commandId]) return COMMAND_LABELS[commandId];
  return { emoji: '❓', label: `Desconocido (${commandId ?? '—'})` };
}
